import React, { useContext } from 'react';
import { AngularServicesContext } from 'react-app';
import { Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import t from 'react-translate';
import { IntegrationTypes, AuthenticatedUser } from 'redux/schemas/models/live-event';
import { getCurrentUserId } from 'redux/selectors/users';

type ZoomReAuthProps = {
  integrationType: IntegrationTypes
  authenticatedUser: AuthenticatedUser
  isLecturePage?: boolean
  isMeetingCreated?: boolean
  creatorFullName?: string
};

const ZoomReAuthenticate: React.FC<ZoomReAuthProps> = ({
  integrationType,
  isLecturePage,
  isMeetingCreated,
  creatorFullName,
  authenticatedUser,
}) => {
  const { RailsRoutes, $location, InstitutionsManager } = useContext(AngularServicesContext);
  const currentUserId = useSelector(getCurrentUserId);
  const catalogId = useSelector((state) => state.app.currentCatalogId);

  const userEmail = authenticatedUser?.accountEmail;
  const isCurrentUser = currentUserId === authenticatedUser?.id;
  const isZoomOAuth = integrationType === IntegrationTypes.ZOOM_USER_LEVEL;
  const isZoomAccountOAuth = integrationType === IntegrationTypes.ZOOM_ACCOUNT_LEVEL;

  // Only required to authenticate button
  // 1. You are the meeting creator and the meeting is created
  // 2. Anyone can re-authenticate if the meeting has not been created
  const showReAuthButton = (isZoomOAuth && ((isCurrentUser) || (!isCurrentUser && !isMeetingCreated)))
    || (isZoomAccountOAuth && isCurrentUser);

  const getOAuthMessage = () => {
    if (isZoomAccountOAuth) {
      return t.INSTITUTIONS.ADVANCED_SETTINGS.ZOOM_INVALID.ACCOUNT_OAUTH_MESSSAGE(userEmail);
    }
    return (!isMeetingCreated)
      ? t.INSTITUTIONS.ADVANCED_SETTINGS.ZOOM_INVALID.OAUTH_MESSAGE_CLONE_COURSE_ONLY(creatorFullName)
      : t.INSTITUTIONS.ADVANCED_SETTINGS.ZOOM_INVALID.OAUTH_MESSAGE(creatorFullName);
  };

  const authenticateAccountZoomOauth = () => {
    if (isZoomAccountOAuth) {
      window.location.href = RailsRoutes.accountZoomOauthUrl(InstitutionsManager.institution.id);
    }
    if (isZoomOAuth) {
      const refererUrl = `${$location.protocol()}://${$location.host()}/#!${$location.path()}${$location.hash()}`;
      window.location.href = RailsRoutes.zoomOAuthInstallationUrl(catalogId, '', refererUrl);
    }
  };

  return (
    <div className='d-flex flex-column align-items-center justify-content-center border-top border-danger bg-gray-7 py-2'>
      {isLecturePage && (
        <div className='text-small font-weight-bolder mb-2'>
          {t.INSTITUTIONS.ADVANCED_SETTINGS.ZOOM_INVALID.ADMIN_VIEW()}
        </div>
      )}
      <div className='text-small mb-2'>
        {getOAuthMessage()}
      </div>
      {showReAuthButton && (
        <Button variant='primary' onClick={authenticateAccountZoomOauth}>
          {t.INSTITUTIONS.ADVANCED_SETTINGS.ZOOM_INVALID.BUTTON()}
        </Button>
      )}
    </div>
  );
};

export default ZoomReAuthenticate;


